import React, { Component, Fragment } from "react";
import ShopToolBar from "../components/ShopToolBar";
import PageTitleBar from "../components/PageTitleBar";
import AppHeader from "./AppHeader";
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

class PageContainer extends Component {
    render() {

        let { shopToolBar, showPageTitle, title,  page, settings } = this.props;
        let pageTitle = title ? title: page.name;
        showPageTitle = showPageTitle === false ? false : true; // default true
        //if (settings.isCatalogueMode === true) {
        //    showPageTitle = true;
        //}
        return (
            <Fragment>
                {/*<Helmet>*/}
                {/*    <title>{pageTitle} | {settings.metaTitle}</title>*/}
                {/*</Helmet>*/}
                <AppHeader settings={settings}/>
                <div className="offcanvas-wrapper">
                    {showPageTitle && <PageTitleBar settings={settings} title={pageTitle} />}
                    <div className={`${(settings.isCatalogueMode ? "container-fluid" : "container")} padding-bottom-3x mb-1`}>
                        {shopToolBar && <ShopToolBar />}
                        {this.props.children}
                    </div>
                </div>
            </Fragment>
        );
    }
}


function mapStateToProps({ page, settings }, ownProps) {
    return { page, settings, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, {  })(PageContainer));


